import { render, staticRenderFns } from "./NewsItem.vue?vue&type=template&id=1c111447"
import script from "./NewsItem.js?vue&type=script&lang=js&external"
export * from "./NewsItem.js?vue&type=script&lang=js&external"
import style0 from "./NewsItem.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports